import { render } from "./BaseSelect.vue?vue&type=template&id=25427f1e&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=25427f1e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25427f1e"]])

export default __exports__